import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import { providePrimeNG } from "primeng/config";

const AuraAmber = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{amber.50}",
      100: "{amber.100}",
      200: "{amber.200}",
      300: "{amber.300}",
      400: "{amber.400}",
      500: "{amber.500}",
      600: "{amber.600}",
      700: "{amber.700}",
      800: "{amber.800}",
      900: "{amber.900}",
      950: "{amber.950}",
    },
  },
});

export const provideTheme = () =>
  providePrimeNG({
    translation: {
      // Is this a good idea? Not sure but I don't have any better idea to get rid of label on file upload button
      choose: "",
    },
    ripple: true,
    theme: {
      preset: AuraAmber,
      options: {
        darkModeSelector: ".dark",
        cssLayer: {
          name: "primeng",
          order: "base, primeng, theme, utilities",
        },
      },
    },
  });
